import { GlobalStore } from '@roc/client-portal-shared/stores';
import { FormStore } from '@roc/feature-app-core';
import {
  makeObservable,
} from 'mobx';
import {
  TaskScopeForm,
  TaskStatusDB,
} from '../types/generalTasksTypes';

const form = {
  fields: {
    title: {
      value: '',
      error: null,
      rule: 'required',
    },
    description: {
      value: '',
      error: null,
      rule: '',
    },
    status: {
      value: TaskStatusDB.PENDING,
      error: null,
      rule: 'required',
    },
    priority: {
      value: '',
      error: null,
      rule: 'required',
    },
    assigneeId: {
      value: null,
      error: null,
      rule: 'required',
      message: 'The assignee is required.',
    },
    assigneeRequired: {
      value: false,
      error: null,
      rule: ''
    },
    loanId: {
      value: '',
      error: null,
      rule: '',
    },
    watchIds: {
      value: null,
      error: null,
      rule: '',
    },
    category: {
      value: null,
      error: null,
      rule: 'required',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class NonLoanTaskFormStore extends FormStore {

  constructor(
    globalStore: GlobalStore
  ) {
    super(form, globalStore);

    makeObservable(this, {});
  }

}
